module.exports = __webpack_public_path__ + "assets/CTA.a2bb30e1.png";